// extracted by mini-css-extract-plugin
export default {"galleryImg":"ImageGalleryItem_galleryImg__T3HBU"};